// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__PsNTl","Navigation":"Layout_Navigation__1kWng","Content":"Layout_Content__2JEzA","ContentFullWidth":"Layout_ContentFullWidth__2tVW2"};